import { href } from '../../app/router';

export type BoardPlace = { label: string; to: string; /** Offer "Back to <label>" in the main menu (a project only). */ back: boolean };

/**
 * Where a board lives, for its title pill and the main menu's way back (P17). The system project « Sans projet » is a
 * section of the dashboard, never a project: its boards say "No project" and lead to the dashboard, with no "back to".
 * Null while the system project is not known yet, so the stored name never shows for a moment.
 */
export function boardPlace({
  project,
  inboxId,
  inboxPending,
  noProjectLabel,
}: {
  project: { id: string; name: string };
  inboxId: string | undefined;
  inboxPending: boolean;
  noProjectLabel: string;
}): BoardPlace | null {
  if (inboxPending) return null;
  if (inboxId === project.id) return { label: noProjectLabel, to: href('home'), back: false };
  return { label: project.name, to: href('project', { projectId: project.id }), back: true };
}
